import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    TextField,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    Chip,
    Container,
    Divider,
    Paper,
    IconButton,
    Badge
} from '@mui/material';
import {
    Search,
    Dashboard,
    QueuePlayNext,
    QuestionAnswer,
    AccountBalance,
    AccessTimeFilled,
    GroupAdd,
    SpeakerGroup,
    IntegrationInstructions,
    SmartToy,
    Assignment,
    AssignmentInd,
    SettingsApplications,
    ArrowForward,
    History,
    EventSeat,
    DisabledByDefault,
    Inventory,
    CallEnd,
    Class,
    DeveloperMode,
    Mail,
    PeopleAlt,
    DynamicForm,
    EmojiObjects,
    CalendarMonth,
    ViewKanban,
    DesktopAccessDisabled,
    DashboardCustomize,
    Phone,
    ChatBubble,
    Business,
    AutoAwesome,
    BarChart,
    ThumbUp,
    CheckCircle,
    Block,
    Description,
    Schedule,
    HomeWork,
    Work,
    Build,
    Security,
    Code,
    Extension,
    PersonAdd,
    PersonRemove,
    People,
    Groups,
    VpnKey,
    AdminPanelSettings,
    Settings,
    Tune,
    DataUsage,
    Backup,
    Storage,
    CloudUpload,
    FileDownload,
    FileCopy,
    Assessment,
    TrendingUp,
    Analytics,
    Speed,
    Timer,
    Poll,
    ContactPhone,
    Feedback,
    School,
    Category,
    Language,
    AccountTree,
    ListAlt,
    PieChart,
    ShowChart,
    Timeline,
    EventNote,
    Today,
    Schedule as ScheduleIcon,
    WorkHistory,
    Cached,
    AccountBalanceWallet,
    GroupWork,
    Functions,
    BusinessCenter,
    ThumbsUpDown,
    LocationCity,
    Widgets,
    DoorSliding,
    KeyboardArrowUp,
    LocationOn,
    Web,
    PriorityHigh,
    ShoppingCart,
    Segment,
    FiberManualRecord,
    LocalOffer,
    Archive,
    Cancel,
    Help,
    Announcement,
    Forum,
    PauseCircleOutline,
    ManageAccounts,
    Engineering,
    Psychology,
    PlayArrow,
    Replay,
    AttachMoney,
    Email,
    Error,
    Numbers,
    Sms,
    NotificationsActive,
    Share as ShareIcon,
    Source,
    HelpOutline as QuestionMark,
    Group,
    Webhook,
    TimelapseRounded,
    Campaign,
    PhoneInTalk
} from '@mui/icons-material';
import AutomationIcon from '@mui/icons-material/Assistant';
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { AbilityContext, Can } from '../../config/ability-context';
import Base from '../../components/layout-base/base';
import Api from '../../services/api';
import { hasAccess as hasGovRevertAccess } from '../../services/govunificationrevert.service';
import { PapiroConsole } from 'src/utils/papiroConsole';

const styles = (theme) => ({
    root: {
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        padding: '0',
        overflow: 'hidden',
    },
    header: {
        backgroundColor: 'white',
        borderBottom: '1px solid #e9ecef',
        padding: '20px 0',
        position: 'sticky',
        top: '0',
        zIndex: 100,
    },
    headerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#2c3e50',
        margin: 0,
    },
    searchField: {
        maxWidth: '400px',
        width: '100%',
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: '8px',
            height: '40px',
            '& fieldset': {
                borderColor: '#dee2e6',
            },
            '&:hover fieldset': {
                borderColor: 'var(--mexx-green-primary)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'var(--mexx-green-primary)',
            },
        },
    },
    contentContainer: {
        display: 'flex',
        minHeight: 'calc(100vh - 150px)',
    },
    sidebar: {
        width: '260px',
        backgroundColor: 'white',
        borderRight: '1px solid #e9ecef',
        padding: '24px 0',
        position: 'sticky',
        top: '80px',
        height: 'calc(100vh - 80px)',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#dee2e6',
            borderRadius: '3px',
        },
    },
    sidebarTitle: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#2c3e50',
        marginBottom: '16px',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    sidebarTitleIcon: {
        color: 'var(--mexx-green-primary)',
        fontSize: '18px',
    },
    anchorList: {
        padding: '0',
    },
    anchorItem: {
        padding: '10px 24px',
        cursor: 'pointer',
        borderLeft: '3px solid transparent',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#f8f9fa',
            borderLeftColor: 'var(--mexx-green-primary)',
        },
        '&.active': {
            backgroundColor: '#f1f8e9',
            borderLeftColor: 'var(--mexx-green-primary)',
            '& .MuiListItemText-primary': {
                color: 'var(--mexx-green-primary)',
                fontWeight: 600,
            }
        }
    },
    anchorText: {
        '& .MuiTypography-root': {
            fontSize: '14px',
            fontWeight: 500,
            color: '#495057',
        }
    },
    scrollToTopButton: {
        position: 'fixed !important',
        bottom: '80px !important',
        right: '24px !important',
        left: 'auto !important',
        width: '56px',
        height: '56px',
        backgroundColor: 'var(--mexx-green-primary)',
        color: 'white',
        borderRadius: '50%',
        boxShadow: '0 4px 12px var(--mexx-green-light)',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        transition: 'all 0.3s ease',
        zIndex: 1000,
        opacity: 0,
        transform: 'translateY(20px)',
        pointerEvents: 'none',
        '&.visible': {
            opacity: 1,
            transform: 'translateY(0)',
            pointerEvents: 'auto',
        },
        '&:hover': {
            backgroundColor: '#7CB342',
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 16px var(--mexx-green-light)',
        }
    },
    mainContent: {
        flex: 1,
        padding: '24px 32px',
        backgroundColor: '#f8f9fa',
        overflowY: 'auto',
        height: 'calc(100vh - 150px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#dee2e6',
            borderRadius: '4px',
        },
    },
    section: {
        marginBottom: '40px',
        scrollMarginTop: '80px',
    },
    sectionHeader: {
        marginBottom: '24px',
        borderBottom: '2px solid #e9ecef',
        paddingBottom: '12px',
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: 600,
        color: '#2c3e50',
        marginBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    sectionIcon: {
        color: 'var(--mexx-green-primary)',
        fontSize: '24px',
    },
    sectionSubtitle: {
        fontSize: '14px',
        color: '#6c757d',
    },
    cardsGrid: {
        gap: '16px',
    },
    configCard: {
        minHeight: '100px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        border: '1px solid #e9ecef',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            borderColor: 'var(--mexx-green-primary)',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                backgroundColor: 'var(--mexx-green-primary)',
            }
        }
    },
    recentCard: {
        borderLeft: '3px solid var(--mexx-green-primary)',
    },
    cardContent: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '16px !important',
        '&:last-child': {
            paddingBottom: '16px !important',
        }
    },
    cardIcon: {
        width: '40px',
        height: '40px',
        backgroundColor: 'var(--mexx-green-light)',
        marginRight: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        flexShrink: 0,
    },
    cardIconSvg: {
        fontSize: '20px',
        color: 'var(--mexx-green-primary)',
    },
    cardInfo: {
        flex: 1,
        minWidth: 0,
    },
    cardTitle: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#2c3e50',
        marginBottom: '2px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    cardDescription: {
        fontSize: '12px',
        color: '#6c757d',
        lineHeight: 1.3,
        wordBreak: 'break-word',
    },
    cardArrow: {
        color: '#ced4da',
        fontSize: '18px',
        transition: 'color 0.3s ease',
    },
    recentBadge: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        backgroundColor: 'var(--mexx-green-primary)',
        color: 'white',
        fontSize: '10px',
        padding: '2px 6px',
        borderRadius: '10px',
        fontWeight: 600,
    }
});

class AdminMenu extends Component {
    static contextType = AbilityContext;

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            activeSection: 'recentes',
            sections: [],
            recentItems: [],
            showScrollToTop: false
        };
    }

    componentDidMount() {
        this.buildSections();

        // "Reverter unificação gov.br" só aparece para os usuários liberados na API (lista de IDs).
        hasGovRevertAccess().then((allowed) => {
            if (allowed && !this.unmounted) {
                this.govRevertAllowed = true;
                this.buildSections();
            }
        });
        this.loadRecentItems();

        // Processo inicial do hash
        this.handleHashChange();

        // Adicionar delay para garantir que as seções estão renderizadas antes de processar a âncora
        setTimeout(() => {
            const hash = window.location.hash.replace('#', '');
            if (hash) {
                // Scroll para a seção se houver hash na URL
                const element = document.getElementById(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        }, 500);

        window.addEventListener('hashchange', this.handleHashChange);

        // Adicionar listener de scroll para botão "ir para o topo"
        setTimeout(() => {
            const mainContent = document.getElementById('admin-main-content');
            if (mainContent) {
                mainContent.addEventListener('scroll', this.handleScroll);
            }
        }, 100);
    }

    componentWillUnmount() {
        this.unmounted = true;
        window.removeEventListener('hashchange', this.handleHashChange);

        const mainContent = document.getElementById('admin-main-content');
        if (mainContent) {
            mainContent.removeEventListener('scroll', this.handleScroll);
        }
    }

    handleHashChange = () => {
        const hash = window.location.hash.replace('#', '');
        if (hash) {
            this.setState({ activeSection: hash });
        }
    };

    handleScroll = () => {
        const mainContent = document.getElementById('admin-main-content');
        if (mainContent) {
            const scrollTop = mainContent.scrollTop;
            const shouldShow = scrollTop > 300;

            if (shouldShow !== this.state.showScrollToTop) {
                this.setState({ showScrollToTop: shouldShow });
            }
        }
    };

    scrollToTop = () => {
        // Scroll do navegador para o topo
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // Scroll do container interno para o topo
        const mainContent = document.getElementById('admin-main-content');
        if (mainContent) {
            mainContent.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    // Mapeamento estático de ícones
    iconMap = {
        'Dashboard': Dashboard,
        'QueuePlayNext': QueuePlayNext,
        'QuestionAnswer': QuestionAnswer,
        'AccountBalance': AccountBalance,
        'AccessTimeFilled': AccessTimeFilled,
        'GroupAdd': GroupAdd,
        'SpeakerGroup': SpeakerGroup,
        'IntegrationInstructions': IntegrationInstructions,
        'SmartToy': SmartToy,
        'Assignment': Assignment,
        'SettingsApplications': SettingsApplications,
        'EmojiObjects': EmojiObjects,
        'Schedule': Schedule,
        'Business': Business,
        'VpnKey': VpnKey,
        'ListAlt': ListAlt,
        'ContactPhone': ContactPhone,
        'Feedback': Feedback,
        'School': School,
        'Description': Description,
        'Category': Category,
        'Language': Language,
        'AccountTree': AccountTree,
        'History': History,
        'Code': Code
    };

    loadRecentItems = () => {
        try {
            const storedItems = localStorage.getItem(`admin-menu-recent-items-${this.userId}`);
            const parsedItems = storedItems ? JSON.parse(storedItems) : [];

            // Reconstrói os itens com ícones válidos
            const recentItems = parsedItems.map(item => ({
                ...item,
                icon: this.iconMap[item.iconName] || Dashboard
            }));

            this.setState({ recentItems });
        } catch (error) {
            console.warn('Erro ao carregar itens recentes:', error);
            this.setState({ recentItems: [] });
        }
    };

    getRecentItemsForDisplay = () => {
        try {
            const storedItems = localStorage.getItem(`admin-menu-recent-items-${this.userId}`);
            if (!storedItems) return [];

            const parsedItems = JSON.parse(storedItems);

            // Reconstrói com ícones válidos de forma robusta
            return parsedItems.map(item => ({
                title: item.title || 'Item sem título',
                description: item.description || 'Sem descrição',
                link: item.link || '#',
                icon: this.iconMap[item.iconName] || Dashboard
            }));
        } catch (error) {
            console.warn('Erro ao processar itens recentes:', error);
            return [];
        }
    };

    saveRecentItem = (item) => {
        try {
            // Prepara item para salvar (sem o componente icon)
            const itemToSave = {
                title: item.title,
                description: item.description,
                link: item.link,
                iconName: item.icon?.name || 'Dashboard' // Salva apenas o nome do ícone
            };

            // Carrega itens atuais
            const storedItems = localStorage.getItem(`admin-menu-recent-items-${this.userId}`);
            let recentItems = storedItems ? JSON.parse(storedItems) : [];

            // Remove item se já existir (para reposicionar)
            recentItems = recentItems.filter(existingItem => existingItem.link !== itemToSave.link);

            // Adiciona o novo item no início
            recentItems.unshift(itemToSave);

            // Mantém apenas os 6 mais recentes
            if (recentItems.length > 6) {
                recentItems = recentItems.slice(0, 6);
            }

            // Salva no localStorage
            localStorage.setItem(`admin-menu-recent-items-${this.userId}`, JSON.stringify(recentItems));

            // Não faz reload - deixa o usuário continuar navegando
            // A próxima vez que abrir a página, os itens estarão lá
        } catch (error) {
            console.warn('Erro ao salvar item recente:', error);
        }
    };

    buildSections = () => {
        const { userSession, intl } = this.props;
        if (!userSession?.user) return;

        this.userId = userSession?.user?.id;
        this.isAdm = false;
        this.isClient = true;
        this.isAdmOrg = false;
        this.isAdmGlobal = false;
        this.isAdmGroup = false;
        this.isTec = false;
        this.isOnlyCoordOrg = false;

        if (
            userSession != null &&
            userSession.user != null &&
            userSession.user.userrole != null
        ) {
            userSession?.user?.userrole.map((item, key) => {
                if (item.role.roletype != 3) {
                    this.isClient = false;
                    PapiroConsole.log('isCLient = false')
                }

                if (
                    item.role.roletype == 0 ||
                    item.role.roletype == 1 ||
                    item.role.roletype == 4
                ) {
                    this.isAdm = true;
                    if (item.role.roletype == 0) {
                        this.isAdmGlobal = true;
                    }
                }
                if (
                    item.role.roletype == 1 &&
                    item.role.roletype != 0 &&
                    !this.isAdmGlobal
                ) {
                    this.isAdmOrg = true;
                }
                if (
                    item.role.roletype == 4 &&
                    item.role.roletype !== 1 &&
                    item.role.roletype != 0 &&
                    !this.isAdmGlobal
                ) {
                    this.isOnlyCoordOrg = true;
                }
                if (item.role.roletype == 2) {
                    this.isTec = true;
                }
            });
        }


        const sections = [];

        // Seção de Itens Recentes - constrói dinamicamente com ícones válidos
        const recentItemsFromStorage = this.getRecentItemsForDisplay();
        sections.push({
            id: 'recentes',
            title: 'Itens Recentes',
            subtitle: 'Acesse rapidamente suas funcionalidades mais utilizadas',
            icon: History,
            items: recentItemsFromStorage
        });

        // 1. DASHBOARDS
        const dashboardItems = [
            {
                title: 'Operação',
                description: 'Dashboard operacional',
                link: `/${this.props.match.params.lang}/dashboard`,
                icon: Dashboard
            },
        ];

        dashboardItems.push(
            {
                title: 'Operação (Novo)',
                description: 'Dashboard operacional (Novo)',
                link: `/${this.props.match.params.lang}/dashboard-operation-new`,
                icon: Dashboard
            }
        )

        if (this.isAdmGlobal || this.isAdm || this.isAdmGroup || this.isAdmOrg) {
            dashboardItems.push(
                {
                    title: 'Produtividade',
                    description: 'Dashboard de produtividade',
                    link: `/${this.props.match.params.lang}/productivitydashboard`,
                    icon: TrendingUp
                }
            )
            dashboardItems.push(
                {
                    title: 'Qualidade',
                    description: 'Dashboard de qualidade',
                    link: `/${this.props.match.params.lang}/qualitydashboard`,
                    icon: Assessment
                }
            )
        }

        sections.push({
            id: 'dashboards',
            title: 'Dashboards',
            subtitle: 'Visualize métricas e indicadores do sistema',
            icon: Dashboard,
            items: dashboardItems
        });

        // Chamados
        const calledItems = [];

        // Minha Pauta - apenas para tecnicos
        if (this.isTec) {
            calledItems.push({
                title: 'Minha Pauta',
                description: 'Visualize sua fila de trabalho pessoal',
                link: `/${this.props.match.params.lang}/agent-workspace`,
                icon: AssignmentInd
            });
        }

        if (this.context.can('List', 'Called')) {
            let linkCalleds = `/${this.props.match.params.lang}/calleds`;
            if (userSession?.user?.enablenewscreencalled) {
                linkCalleds = `/${this.props.match.params.lang}/new-calleds`;
            }

            calledItems.push({
                title: 'Lista de Chamados',
                description: 'Visualize e gerencie todos os chamados',
                link: `/${this.props.match.params.lang}/new-calleds`,
                icon: QueuePlayNext
            });
        }

        // Visualizações alternativas - sempre disponíveis se pode listar chamados
        if (this.context.can('List', 'Called')) {
            if (Api != null && (Api.getSassHirerId() != 1011)) {
                calledItems.push({
                    title: 'Kanban',
                    description: 'Visualização em quadro Kanban',
                    link: `/${this.props.match.params.lang}/kanban`,
                    icon: ViewKanban
                });
            }

            if (!this.isClient) {
                calledItems.push({
                    title: 'Calendário',
                    description: 'Visualização em calendário',
                    link: `/${this.props.match.params.lang}/calendar`,
                    icon: CalendarMonth
                });
            }
        }

        if (this.context.can('Open', 'Called')) {
            calledItems.push({
                title: 'Portal',
                description: 'Portal de atendimento',
                link: `/${this.props.match.params.lang}/portal`,
                icon: Web
            });
        }

        // Gestão de chamados
        if (this.context.can('List', 'AssignedCalled')) {
            calledItems.push({
                title: 'Atribuir Chamado',
                description: 'Atribuir chamados aos técnicos',
                link: `/${this.props.match.params.lang}/assignedcalleds`,
                icon: PersonAdd
            });
        }

        if (this.context.can('List', 'CalledRejection')) {
            calledItems.push({
                title: 'Chamados Rejeitados',
                description: 'Chamados rejeitados',
                link: `/${this.props.match.params.lang}/called-rejection`,
                icon: DesktopAccessDisabled
            });
        }

        if (this.isAdmGlobal || this.isAdm || this.isAdmGroup || this.isAdmOrg || this.isTec) {
            calledItems.push({
                title: 'Chamados Encerrados',
                description: 'Chamados encerrados',
                link: `/${this.props.match.params.lang}/finishedCalleds`,
                icon: CallEnd
            });
        }

        if (userSession?.user?.canuserviewarchivedcalleds) {
            calledItems.push({
                title: 'Chamados Arquivados',
                description: 'Chamados arquivados do sistema',
                link: `/${this.props.match.params.lang}/archived-calleds`,
                icon: Inventory
            });
        }

        calledItems.push({
            title: 'Chamados Cancelados',
            description: 'Chamados cancelados',
            link: `/${this.props.match.params.lang}/canceled-calleds`,
            icon: Cancel
        });

        if (this.context.can('List', 'CalledClassification')) {
            calledItems.push({
                title: 'Classificação dos Chamados',
                description: 'Classificação e categorização',
                link: `/${this.props.match.params.lang}/calledclassifications`,
                icon: Class
            });
        }

        if (this.context.can('Create', 'Called')) {
            calledItems.push({
                title: 'Novo Chamado',
                description: 'Criar um novo chamado',
                link: `/${this.props.match.params.lang}/called-registration`,
                icon: QueuePlayNext
            });
        }

        // Base de Conhecimento para clientes
        if (Api != null && (Api.getSassHirerId() == 1011)) {
            // if (this.isClient) {
            //     PapiroConsole.log('Menu Admin - usuário é cliente')
            //     if (this.context.can('List', 'KnowledgeBase')) {
            //         calledItems.push({
            //             title: 'Base de Conhecimento',
            //             description: 'Base de conhecimento para clientes',
            //             link: `/${this.props.match.params.lang}/knowledgebases-client`,
            //             icon: EmojiObjects
            //         });
            //     }
            // } else {
            //     calledItems.push({
            //         title: 'Painel de Conhecimento',
            //         description: 'Painel de conhecimento',
            //         link: `/${this.props.match.params.lang}/knowledgebases-client`,
            //         icon: School
            //     });
            // }
        } else {
            if (!this.isClient) {
                // Para não clientes - Centro de Conhecimento
                PapiroConsole.log("entrei no knowledge base do adm/tec")
                calledItems.push({
                    title: 'Centro de Conhecimento',
                    description: 'Centro de conhecimento',
                    link: `/${this.props.match.params.lang}/knowledgebases`,
                    icon: School
                });
            }
        }

        // NPS Search
        if (this.isAdmGlobal) {
            calledItems.push({
                title: 'Pesquisa NPS',
                description: 'Pesquisa de satisfação NPS',
                link: `/${this.props.match.params.lang}/nps-search`,
                icon: ThumbsUpDown
            });
        }

        if (calledItems.length > 0) {
            sections.push({
                id: 'chamados',
                title: 'Gestão de Chamados',
                subtitle: 'Gerencie tickets e solicitações de suporte',
                icon: QueuePlayNext,
                items: calledItems
            });
        }

        // Marketing — transmissões (broadcast) de WhatsApp em lote. Menu principal próprio.
        // FASE 1 (mock): visível pra não-clientes; será amarrado à permission "Marketing" real depois.
        if (!this.isClient) {
            const marketingItems = [
                {
                    title: this.props.intl.formatMessage({ id: 'menu.marketing.broadcasts' }),
                    description: this.props.intl.formatMessage({ id: 'marketing.subtitle' }),
                    link: `/${this.props.match.params.lang}/marketing`,
                    icon: Campaign
                },
                {
                    title: this.props.intl.formatMessage({ id: 'menu.marketing.recipients' }),
                    description: this.props.intl.formatMessage({ id: 'marketing.field.list' }),
                    link: `/${this.props.match.params.lang}/marketing/lists`,
                    icon: Campaign
                }
            ];
            sections.push({
                id: 'marketing',
                title: this.props.intl.formatMessage({ id: 'menu.marketing' }),
                subtitle: this.props.intl.formatMessage({ id: 'marketing.subtitle' }),
                icon: Campaign,
                items: marketingItems
            });
        }

        // 3. 2TALK - Comunicação e Mensageria
        const talkItems = [];

        // Conversas - item principal
        if ((this.isTec || this.isAdm || this.isAdmGlobal) && !this.isClient) {
            talkItems.push({
                title: 'Conversas',
                description: 'Gerencie conversas e atendimentos',
                link: `/${this.props.match.params.lang}/chat-attendance-list`,
                icon: QuestionAnswer
            });

            // GRUPOS (WhatsApp) — layout novo, mesma secao de Mensageria.
            talkItems.push({
                title: this.props.intl.formatMessage({ id: 'menu.provider.groups' }),
                description: this.props.intl.formatMessage({ id: 'providergroup.menu.description' }),
                link: `/${this.props.match.params.lang}/provider-groups`,
                icon: Forum
            });
        }

        // Configurações de canais e comunicação
        if (this.isAdm || this.isAdmGlobal) {
            talkItems.push({
                title: 'Canais',
                description: 'Configure canais de comunicação',
                link: `/${this.props.match.params.lang}/channel`,
                icon: Forum
            });

            talkItems.push({
                title: 'Chatbots',
                description: 'Configure chatbots automatizados',
                link: `/${this.props.match.params.lang}/chatbots`,
                icon: SmartToy
            });

            talkItems.push({
                title: 'Classificação de conversas',
                description: 'Configure classificações de conversas',
                link: `/${this.props.match.params.lang}/chatclassifications`,
                icon: ThumbsUpDown
            });

            talkItems.push({
                title: 'Habilitar agentes',
                description: 'Configure agentes habilitados',
                link: `/${this.props.match.params.lang}/enableagents`,
                icon: GroupAdd
            });

            talkItems.push({
                title: 'Regras de Atendimento',
                description: 'Configure regras de atendimento',
                link: `/${this.props.match.params.lang}/rulesattendance`,
                icon: SettingsApplications
            });

            talkItems.push({
                title: 'Respostas Rápidas',
                description: 'Configure respostas rápidas',
                link: `/${this.props.match.params.lang}/quick-responses`,
                icon: Speed
            });

             if (this.isAdmGlobal) {
                talkItems.push({
                    title: 'Mensagens de modelo de provedor',
                    description: 'Configure textos padrao dos modelos de provedor',
                    link: `/${this.props.match.params.lang}/provider-template-message-config`,
                    icon: Description
                });
            }

            talkItems.push({
                title: 'Modelos',
                description: 'Gerencie modelos de mensagens',
                link: `/${this.props.match.params.lang}/template-message`,
                icon: Description
            });

           

            talkItems.push({
                title: 'Webchats',
                description: 'Configure webchat',
                link: `/${this.props.match.params.lang}/webchats`,
                icon: ChatBubble
            });

            // Gestão de clientes e empresas
            talkItems.push({
                title: 'Clientes',
                description: 'Gerencie clientes do sistema 2Talk',
                link: `/${this.props.match.params.lang}/customers`,
                icon: PeopleAlt
            });

            talkItems.push({
                title: 'Empresas',
                description: 'Gerencie empresas',
                link: `/${this.props.match.params.lang}/companies`,
                icon: BusinessCenter
            });

            // Solicitações de registro
            talkItems.push({
                title: 'Solicitações de registro de telefone',
                description: 'Solicitações de registro de provedor',
                link: `/${this.props.match.params.lang}/phoneregistrationrequests`,
                icon: Phone
            });

            // Relatórios de 2Talk
            talkItems.push({
                title: 'Relatório de conversas',
                description: 'Relatórios de conversas 2Talk',
                link: `/${this.props.match.params.lang}/2talk-chat-report`,
                icon: BarChart
            });

            talkItems.push({
                title: 'Relatório de pesquisa de satisfação',
                description: 'Relatórios de pesquisa de satisfação',
                link: `/${this.props.match.params.lang}/2talk-satisfactionsurvey-report`,
                icon: ThumbUp
            });
        }

        if (talkItems.length > 0) {
            sections.push({
                id: 'comunicacao',
                title: 'Comunicação e Mensageria',
                subtitle: 'Sistema completo de comunicação e chat',
                icon: QuestionAnswer,
                items: talkItems
            });
        }

        // 4. GUIA DO USUÁRIO - TODOS OS 7 ITENS
        const guideItems = this.isAdm ?
            [
                {
                    title: 'Assunto do FAQ',
                    description: 'Gerencie assuntos do FAQ',
                    link: `/${this.props.match.params.lang}/faq-subject`,
                    icon: QuestionMark
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases`,
                    icon: School
                },
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq`,
                    icon: Help
                },
                {
                    title: 'Feedback de Notícia',
                    description: 'Feedback das notícias',
                    link: `/${this.props.match.params.lang}/feedbackarticles`,
                    icon: Feedback
                },
                {
                    title: 'Notícias',
                    description: 'Gerencie notícias do sistema',
                    link: `/${this.props.match.params.lang}/articles`,
                    icon: Announcement
                },
                {
                    title: 'Portal do Cliente',
                    description: 'Configure portal do cliente',
                    onClick: _ => { window.open(`/${this.props.match.params.lang}/client-portal-external`, '_blank') },
                    icon: Web
                },
                {
                    title: 'Seção de notícias',
                    description: 'Seções de notícias',
                    link: `/${this.props.match.params.lang}/articles-sections`,
                    icon: Category
                }
            ]
            :
            [
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq-list-client`,
                    icon: Help
                },
                {
                    title: 'Notícias',
                    description: 'Notícias do sistema',
                    link: `/${this.props.match.params.lang}/articles-client`,
                    icon: Feedback
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases-client`,
                    icon: Announcement
                },
                {
                    title: 'Portal do Cliente',
                    description: 'Acesse o portal do cliente',
                    onClick: _ => { window.open(`/${this.props.match.params.lang}/client-portal-external`, '_blank') },
                    icon: Web
                },
            ];

        // 4. SPEED PROD - GUIA DO USUÁRIO - 7 ITENS ADM / 3 ITENS CLIENTE
        const guideItemsSpeedPROD = this.isAdm ?
            [
                {
                    title: 'Assunto do FAQ',
                    description: 'Gerencie assuntos do FAQ',
                    link: `/${this.props.match.params.lang}/faq-subject`,
                    icon: QuestionMark
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases`,
                    icon: School
                },
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq`,
                    icon: Help
                },
                {
                    title: 'Feedback de Notícia',
                    description: 'Feedback das notícias',
                    link: `/${this.props.match.params.lang}/feedbackarticles`,
                    icon: Feedback
                },
                {
                    title: 'Notícias',
                    description: 'Gerencie notícias do sistema',
                    link: `/${this.props.match.params.lang}/articles`,
                    icon: Announcement
                },
                {
                    title: 'Portal do Cliente',
                    description: 'Configure portal do cliente',
                    onClick: _ => { window.open(`/${this.props.match.params.lang}/client-portal-external`, '_blank') },
                    icon: Web
                },
                {
                    title: 'Seção de notícias',
                    description: 'Seções de notícias',
                    link: `/${this.props.match.params.lang}/articles-sections`,
                    icon: Category
                }
            ]
            : [
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq-list-client`,
                    icon: Help
                },
                {
                    title: 'Notícias',
                    description: 'Notícias do sistema',
                    onClick: _ => { window.open(`https://www.gov.br/gestao/pt-br/assuntos/central-de-atendimento`, '_blank') },
                    // link: `/${this.props.match.params.lang}/articles-client`,
                    icon: Feedback
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases-client`,
                    icon: Announcement
                }
            ];

        // 4. SPEED HOMOLOGA - GUIA DO USUÁRIO - 7 ITENS ADM / 3 ITENS CLIENTE
        const guideItemsSpeedHOMOLOGA = this.isAdm ?
            [
                {
                    title: 'Assunto do FAQ',
                    description: 'Gerencie assuntos do FAQ',
                    link: `/${this.props.match.params.lang}/faq-subject`,
                    icon: QuestionMark
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases`,
                    icon: School
                },
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq`,
                    icon: Help
                },
                {
                    title: 'Feedback de Notícia',
                    description: 'Feedback das notícias',
                    link: `/${this.props.match.params.lang}/feedbackarticles`,
                    icon: Feedback
                },
                {
                    title: 'Notícias',
                    description: 'Gerencie notícias do sistema',
                    link: `/${this.props.match.params.lang}/articles`,
                    icon: Announcement
                },
                {
                    title: 'Portal do Cliente',
                    description: 'Configure portal do cliente',
                    onClick: _ => { window.open(`/${this.props.match.params.lang}/client-portal-external`, '_blank') },
                    icon: Web
                },
                {
                    title: 'Seção de notícias',
                    description: 'Seções de notícias',
                    link: `/${this.props.match.params.lang}/articles-sections`,
                    icon: Category
                }
            ]
            : [
                {
                    title: 'FAQ',
                    description: 'Perguntas frequentes',
                    link: `/${this.props.match.params.lang}/faq-list-client`,
                    icon: Help
                },
                {
                    title: 'Notícias',
                    description: 'Notícias do sistema',
                    onClick: _ => { window.open(`https://www.gov.br/gestao/pt-br/assuntos/central-de-atendimento`, '_blank') },
                    // link: `/${this.props.match.params.lang}/articles-client`,
                    icon: Feedback
                },
                {
                    title: 'Base de Conhecimento',
                    description: 'Base de conhecimento do sistema',
                    link: `/${this.props.match.params.lang}/knowledgebases-client`,
                    icon: Announcement
                }
            ];

        // 4. GUIA DO USUÁRIO - Escolha conforme o SassHirerId
        if (Api != null && Api.getSassHirerId() == 1011) {
            sections.push({
                id: 'guia-usuario',
                title: 'Guia do Usuário',
                subtitle: 'Documentação e suporte ao usuário',
                icon: School,
                items: guideItemsSpeedPROD
            });
        } else if (Api != null && Api.getSassHirerId() == 15) {
            sections.push({
                id: 'guia-usuario',
                title: 'Guia do Usuário',
                subtitle: 'Documentação e suporte ao usuário',
                icon: School,
                items: guideItemsSpeedHOMOLOGA
            });
        } else {
            sections.push({
                id: 'guia-usuario',
                title: 'Guia do Usuário',
                subtitle: 'Documentação e suporte ao usuário',
                icon: School,
                items: guideItems
            });
        }

        // 5. FORMULÁRIOS EXTERNOS
        if (this.context.can("List", "CalledServiceSettings") || this.isAdm) {
            const formsItems = [
                {
                    title: 'Formulários Externos',
                    description: 'Gerencie formulários externos',
                    link: `/${this.props.match.params.lang}/calledservicesettings`,
                    icon: Assignment
                }
            ]

            sections.push({
                id: 'formularios-externos',
                title: 'Formulários externos',
                subtitle: 'Gerencie formulários externos',
                icon: Assignment,
                items: formsItems
            });
        }

        // 6. GRUPOS
        /*
        const groupsItems = [
          {
            title: 'Grupos',
            description: 'Gerencie grupos de usuários',
            link: `/${this.props.match.params.lang}/groups`,
            icon: Group
          }
        ];
    
        sections.push({
          id: 'grupos',
          title: 'Grupos',
          subtitle: 'Gerencie grupos de usuários',
          icon: Group,
          items: groupsItems
        });
        */

        if (this.context.can("List", "Organization")) {
            // 7. ORGANIZAÇÕES - Com controle de permissões
            const orgItems = [];

            // Grupos de usuários
            if (this.context.can('List', 'Group')) {
                orgItems.push({
                    title: 'Grupos',
                    description: 'Gerencie grupos de usuários',
                    link: `/${this.props.match.params.lang}/groups`,
                    icon: Group
                });
            }

            // Organizações principais - apenas admin global ou com permissão explícita
            if (this.isAdmGlobal || this.isAdm) {
                orgItems.push({
                    title: 'Organização',
                    description: 'Gerencie organizações',
                    link: `/${this.props.match.params.lang}/organizations`,
                    icon: AccountBalance,
                    subItems: [
                            'Dados da organização',
                            'Endereço da Organização',
                            'Feriados da Organização',
                            'Campos Personalizados',
                            'Checklist',
                            'SLA da Organização',
                            'Categorias da Organização',
                            'Departamentos da Organização',
                            'Patrimônios da Organização',
                            'Materiais da Organização',
                            'Configuração de listagem de chamados',
                            'Configuração de Serviços Adicionais',
                            'Configuração do laudo do chamado',
                            'Configurações de Email',
                            'Associar Novos Usuários'
                        ]                    
                });
            }

            // Categorias da Organização
            if (this.context.can('List', 'OrganizationCategory')) {
                orgItems.push({
                    title: 'Categorias da Organização',
                    description: 'Categorias organizacionais',
                    link: `/${this.props.match.params.lang}/organizationcategories`,
                    icon: Category
                });
            }

            // Departamentos
            if (this.context.can('List', 'OrganizationDepartament')) {
                orgItems.push({
                    title: 'Departamentos',
                    description: 'Gerencie departamentos',
                    link: `/${this.props.match.params.lang}/organizationdepartaments`,
                    icon: Business
                });
            }

            // Materiais organizacionais
            if (this.context.can('List', 'OrganizationMaterial')) {
                orgItems.push({
                    title: 'Materiais',
                    description: 'Gerencie materiais organizacionais',
                    link: `/${this.props.match.params.lang}/organizationmaterials`,
                    icon: Inventory
                });
            }

            // Patrimônios organizacionais
            if (this.context.can('List', 'OrganizationPatrimony')) {
                orgItems.push({
                    title: 'Patrimônios',
                    description: 'Gerencie patrimônios organizacionais',
                    link: `/${this.props.match.params.lang}/organizationpatrimonies`,
                    icon: HomeWork
                });
            }

            // SLA da Organização
            if (this.context.can('List', 'OrganizationSla')) {
                orgItems.push({
                    title: 'SLA da Organização',
                    description: 'SLA específico da organização',
                    link: `/${this.props.match.params.lang}/organizationslas`,
                    icon: Timer
                });
            }

            // Configurações específicas de organizações (normalmente apenas admin)
            if (this.isAdm || this.isAdmGlobal) {
                orgItems.push({
                    title: 'Configuração de listagem de chamados',
                    description: 'Configure listagem de chamados',
                    link: `/${this.props.match.params.lang}/calledlistdatas`,
                    icon: Settings
                });

                orgItems.push({
                    title: 'Configuração de Serviços Adicionais',
                    description: 'Configure serviços adicionais',
                    link: `/${this.props.match.params.lang}/additional-service-config`,
                    icon: Settings
                });

                orgItems.push({
                    title: 'Configurações do laudo do chamado',
                    description: 'Configure laudos de chamados',
                    link: `/${this.props.match.params.lang}/called-report-configs`,
                    icon: Description
                });
            }

            sections.push({
                id: 'organizacoes',
                title: 'Grupos e Organizações',
                subtitle: 'Gestão completa organizacional',
                icon: AccountBalance,
                items: orgItems
            });
        }

        // 9. CONTROLE DE USUÁRIO - 4 ITENS
        /*
            const userControlItems = [
              {
                title: 'Agentes',
                description: 'Gerencie agentes do sistema',
                link: `/${this.props.match.params.lang}/agents`,
                icon: People
              },
              {
                title: 'Clientes',
                description: 'Gerencie clientes',
                link: `/${this.props.match.params.lang}/clients`,
                icon: PersonAdd
              },
              {
                title: 'Funcionalidades',
                description: 'Configure funcionalidades',
                link: `/${this.props.match.params.lang}/functionalities`,
                icon: Build
              },
              {
                title: 'Perfil de Acesso',
                description: 'Configure perfis de acesso',
                link: `/${this.props.match.params.lang}/access-profiles`,
                icon: VpnKey
              }
            ];
        
            sections.push({
              id: 'controle-usuario',
              title: 'Controle de Usuário',
              subtitle: 'Gerencie usuários e acessos',
              icon: ManageAccounts,
              items: userControlItems
            });
        */

        if (this.isAdmGlobal) {
            // 11. INTEGRAÇÕES - 4 ITENS
            const integrationItems = [
                {
                    title: 'Autenticação',
                    description: 'Configure autenticação de integrações',
                    link: `/${this.props.match.params.lang}/authentication`,
                    icon: VpnKey
                },
                {
                    title: 'Serviços',
                    description: 'Gerencie serviços de integração',
                    link: `/${this.props.match.params.lang}/integration-service`,
                    icon: IntegrationInstructions
                },
                {
                    title: 'Variáveis',
                    description: 'Configure variáveis de integração',
                    link: `/${this.props.match.params.lang}/variable`,
                    icon: Code
                },
                {
                    title: 'Parâmetro',
                    description: 'Configure parâmetros de integração',
                    link: `/${this.props.match.params.lang}/params`,
                    icon: Tune
                },
                {
                    title: 'Webhooks',
                    description: 'Configure webhooks para notificações externas',
                    link: `/${this.props.match.params.lang}/webhooks`,
                    icon: Webhook
                },
                {
                    title: 'Plataformas VOIP',
                    description: 'Habilite e configure as plataformas de telefonia',
                    link: `/${this.props.match.params.lang}/voip-platforms`,
                    icon: PhoneInTalk
                }
            ];

            sections.push({
                id: 'integracoes',
                title: 'Integrações',
                subtitle: 'Configure integrações externas',
                icon: IntegrationInstructions,
                items: integrationItems
            });
        }

        const automationItems = []
        if (Api != null && (Api.getSassHirerId() != 1011) && (Api.getSassHirerId() != 15) && this.isAdmGlobal) {
            // 12. AUTOMAÇÕES - 1 ITEM
            automationItems.push({
                title: 'Automação',
                description: 'Configure automações do sistema',
                link: `/${this.props.match.params.lang}/automationV2`,
                icon: AutomationIcon
            })
        }

        if (this.isAdmGlobal || this.isAdm || this.isAdmOrg || this.isAdmGroup || this.isTec) {
            automationItems.push({
                title: 'Macros',
                description: 'Configure os macros do sistema',
                link: `/${this.props.match.params.lang}/macro-list`,
                icon: AutomationIcon
            });
        }

        sections.push({
            id: 'automacoes',
            title: 'Automações',
            subtitle: 'Gerencie automações',
            icon: AutomationIcon,
            items: automationItems
        });

        if (this.isAdmGlobal) {
            // 13. IA - 2 ITENS
            const iaItems = [
                {
                    title: 'LLM',
                    description: 'Configure modelos de linguagem',
                    link: `/${this.props.match.params.lang}/llms`,
                    icon: Psychology
                },
                {
                    title: 'Eventos de LLM',
                    description: 'Gerencie eventos de LLM',
                    link: `/${this.props.match.params.lang}/llm-events`,
                    icon: SmartToy
                }
            ];

            sections.push({
                id: 'ia',
                title: 'IA',
                subtitle: 'Inteligência Artificial',
                icon: Psychology,
                items: iaItems
            });
        }

        // 14. RELATÓRIOS - Com controle de permissões

        const reportItems = [];

        // Relatórios de usuários/agentes
        if (this.isAdm) {
            // Agendamentos (agendamento e compartilhamento de relatórios) — 1º item de Relatórios
            if (this.context.can('List', 'CalledReport')) {
                reportItems.push({
                    title: this.props.intl.formatMessage({ id: 'report.schedule.menu.short' }),
                    description: this.props.intl.formatMessage({ id: 'report.schedule.menu.description' }),
                    link: `/${this.props.match.params.lang}/report-schedules`,
                    icon: Schedule
                });
            }

            reportItems.push({
                title: 'Agentes',
                description: 'Relatório de agentes',
                link: `/${this.props.match.params.lang}/agents-report`,
                icon: People
            });

            // Relatório de auditoria - normalmente apenas admin
            reportItems.push({
                title: 'Auditoria',
                description: 'Relatório de auditoria',
                link: `/${this.props.match.params.lang}/audit-report`,
                icon: Security
            });

            // Relatórios de automações - normalmente admin
            if (!this.isClient) {
                reportItems.push({
                    title: 'Automações Executadas',
                    description: 'Relatório de automações executadas',
                    link: `/${this.props.match.params.lang}/automation-execution-reports`,
                    icon: PlayArrow
                });

                reportItems.push({
                    title: 'Automações',
                    description: 'Relatório de automações',
                    link: `/${this.props.match.params.lang}/automation-reports`,
                    icon: AutomationIcon
                });

                reportItems.push({
                    title: this.props.intl.formatMessage({ id: 'conversation.service.report' }),
                    description: this.props.intl.formatMessage({ id: 'conversation.service.report.description' }),
                    link: `/${this.props.match.params.lang}/conversation-service-report`,
                    icon: QuestionAnswer
                });
            }

            // Relatório principal de chamados
            if (this.context.can('List', 'CalledReport')) {
                reportItems.push({
                    title: 'Chamados',
                    description: 'Relatório de chamados',
                    link: `/${this.props.match.params.lang}/calledreports`,
                    icon: Assignment
                });
            }

            // Relatório de chamados arquivados
            if (this.isAdmGlobal || this.isAdm) {
                reportItems.push({
                    title: 'Chamados Arquivados',
                    description: 'Relatório de chamados arquivados',
                    link: `/${this.props.match.params.lang}/calleds-organizations-report-archived`,
                    icon: Assignment
                });
            }

            // Relatório de chamados por organização
            reportItems.push({
                title: 'Chamados X Organização',
                description: 'Relatório de chamados por organização',
                link: `/${this.props.match.params.lang}/calleds-organizations-report`,
                icon: Assignment
            });

            // Relatório de chamados por organização sintético
            reportItems.push({
                title: 'Chamados X Organização Sintético',
                description: 'Relatório de chamados por organização sintético',
                link: `/${this.props.match.params.lang}/calleds-organizations-synthetic-report`,
                icon: Assignment
            });

            // Relatório de chamados geral
            if (this.isAdmGlobal) {
                reportItems.push({
                    title: 'Chamados Geral',
                    description: 'Relatório geral de chamados',
                    link: `/${this.props.match.params.lang}/calleds-organizations-report-general`,
                    icon: Assignment
                });
            }

            // Relatório de chamados Origem x Categoria
            reportItems.push({
                title: 'Chamados Origem x Categoria',
                description: 'Relatório de chamados por origem e categoria',
                link: `/${this.props.match.params.lang}/calleds-origin-categories-report`,
                icon: Assignment
            });

            // Relatório de chamados por organização (encerrados com SLA estourado)
            reportItems.push({
                title: 'Chamados X Organização (SLA Estourado)',
                description: 'Relatório de chamados encerrados com SLA estourado por organização',
                link: `/${this.props.match.params.lang}/calleds-organizations-breach-sla-report`,
                icon: Assignment
            });

            // Relatório de materiais - permissão específica
            if (this.context.can('List', 'MaterialReport')) {
                reportItems.push({
                    title: 'Chamados por Materiais',
                    description: 'Relatório de chamados por materiais',
                    link: `/${this.props.match.params.lang}/materialreports`,
                    icon: Inventory
                });
            }

            // Relatório de chamados reabertos
            reportItems.push({
                title: 'Chamados Reabertos',
                description: 'Relatório de chamados reabertos',
                link: `/${this.props.match.params.lang}/reopened-calleds-report`,
                icon: Inventory
            });

            // Relatório de chat - permissão específica
            if (this.context.can('List', 'ChatReport')) {
                reportItems.push({
                    title: 'Chat',
                    description: 'Relatório de chat',
                    link: `/${this.props.match.params.lang}/chatreports`,
                    icon: QuestionAnswer
                });
            }

            // Relatório de checklist - permissão específica
            if (this.context.can('List', 'ChecklistReport')) {
                reportItems.push({
                    title: 'Checklist',
                    description: 'Relatório de checklist',
                    link: `/${this.props.match.params.lang}/checklistreports`,
                    icon: CheckCircle
                });
            }

            // Relatório de classificação de chamados
            reportItems.push({
                title: 'Classificação dos Chamados',
                description: 'Relatório de classificação dos chamados',
                link: `/${this.props.match.params.lang}/called-classification-reports`,
                icon: AttachMoney
            });

            // Relatório de custos - permissão específica
            if (this.context.can('List', 'CostReport')) {
                reportItems.push({
                    title: 'Custos de atendimentos',
                    description: 'Relatório de custos',
                    link: `/${this.props.match.params.lang}/costreports`,
                    icon: AttachMoney
                });
            }

            // Dashboard gerencial - permissão específica
            if (this.context.can('List', 'DashboardReport')) {
                reportItems.push({
                    title: 'Dashboard gerencial',
                    description: 'Dashboard gerencial',
                    link: `/${this.props.match.params.lang}/dashboardreports`,
                    icon: Dashboard
                });
            }

            // Relatório de distribuição de atendimentos
            reportItems.push({
                title: 'Distribuição de Atendimentos',
                description: 'Relatório de distribuição automática de chamados e chats',
                link: `/${this.props.match.params.lang}/distribution-report`,
                icon: AccountTree
            });

            // Relatório do mural de avisos
            reportItems.push({
                title: 'Relatório do Mural',
                description: 'Relatório de avisos do Mural, com total de leituras e quem visualizou',
                link: `/${this.props.match.params.lang}/announcement-report`,
                icon: Campaign
            });

            if (this.isAdmGlobal) {
                reportItems.push({
                    title: 'Relatório de Logs Mensageria',
                    description: 'Relatório de Logs Mensageria',
                    link: `/${this.props.match.params.lang}/messaging-channel-log-report`,
                    icon: AccountTree
                });

                reportItems.push({
                    title: 'Erros de Encerramento de Chamado',
                    description: 'Chamados com falha no encerramento assincrono',
                    link: `/${this.props.match.params.lang}/called-closing-error-report`,
                    icon: AccountTree
                });

                reportItems.push({
                    title: 'Processamento de Documentos de LLM',
                    description: 'Execuções da indexação de documentos das bases de LLM',
                    link: `/${this.props.match.params.lang}/llm-document-processing-report`,
                    icon: Description
                });
            }

            // Relatório de envio de emails - permissão específica
            if (this.context.can('List', 'SendMailReport')) {
                reportItems.push({
                    title: 'Emails Enviados',
                    description: 'Relatório de emails enviados',
                    link: `/${this.props.match.params.lang}/sendmailreports`,
                    icon: Email
                });
            }

            // Relatório de erros reportados
            reportItems.push({
                title: 'Erros Reportados',
                description: 'Relatório de erros reportados',
                link: `/${this.props.match.params.lang}/usererrorreport`,
                icon: Email
            });

            // Relatório de execução de webhooks
            if (this.isAdm) {
                reportItems.push({
                    title: 'Execução de Webhooks',
                    description: 'Relatório de execuções de webhooks',
                    link: `/${this.props.match.params.lang}/webhook-execution-report`,
                    icon: Webhook
                });
            }

            // Relatório de materiais - permissão específica
            if (this.context.can('List', 'MaterialReport')) {
                reportItems.push({
                    title: 'First Call Resolution (FCR)',
                    description: 'Relatório de First Call Resolution',
                    link: `/${this.props.match.params.lang}/reportfcr`,
                    icon: Email
                });
            }

            // Relatório de horas reportadas
            reportItems.push({
                title: 'Horas Reportadas',
                description: 'Relatório de horas reportadas',
                link: `/${this.props.match.params.lang}/hours-report`,
                icon: Email
            });

            reportItems.push({
                title: 'Organizações x Categorias',
                description: 'Relatório organizações x categorias',
                link: `/${this.props.match.params.lang}/organizations-categories-report`,
                icon: AccountTree
            });

            // Relátorio de pausas no trabalho
            reportItems.push({
                title: 'Pausas no trabalho',
                description: 'Relatórios de pausas no trabalho',
                link: `/${this.props.match.params.lang}/break-work-report`,
                icon: AccessTimeFilledIcon
            });

            reportItems.push({
                title: 'Quantitativo de chamados',
                description: 'Relatório quantitativo',
                link: `/${this.props.match.params.lang}/quantitative-calleds-report`,
                icon: Numbers
            });
            
            reportItems.push({
                title: 'Quantitativo de conversas',
                description: 'Relatório quantitativo de conversas',
                link: `/${this.props.match.params.lang}/quantitative-chats-report`,
                icon: Numbers
            });

            reportItems.push({
                title: 'SMS Enviados',
                description: 'Relatório de SMS',
                link: `/${this.props.match.params.lang}/sendsmsreports`,
                icon: Sms
            });

            reportItems.push({
                title: 'Times x Técnicos',
                description: 'Relatório times x técnicos',
                link: `/${this.props.match.params.lang}/techinicalteamusers-report`,
                icon: Groups
            });

            reportItems.push({
                title: 'Times',
                description: 'Relatório de times',
                link: `/${this.props.match.params.lang}/techinicalteam-report`,
                icon: Groups
            });

            reportItems.push({
                title: 'Usuários',
                description: 'Relatório de usuários',
                link: `/${this.props.match.params.lang}/users-report`,
                icon: People
            });
        } else if (this.isTec && !this.isAdmGlobal) {
            // Itens de relatório para técnicos

            // Agendamentos (agendamento e compartilhamento de relatórios) — 1º item de Relatórios
            if (this.context.can('List', 'CalledReport')) {
                reportItems.push({
                    title: this.props.intl.formatMessage({ id: 'report.schedule.menu.short' }),
                    description: this.props.intl.formatMessage({ id: 'report.schedule.menu.description' }),
                    link: `/${this.props.match.params.lang}/report-schedules`,
                    icon: Schedule
                });
            }

            // Relatório principal de chamados
            if (this.context.can('List', 'CalledReport')) {
                reportItems.push({
                    title: 'Chamados',
                    description: 'Relatório de chamados',
                    link: `/${this.props.match.params.lang}/calledreports`,
                    icon: Assignment
                });
            }

            // Relatório de horas reportadas
            reportItems.push({
                title: 'Horas Reportadas',
                description: 'Relatório de horas reportadas',
                link: `/${this.props.match.params.lang}/hours-report`,
                icon: Email
            });

            reportItems.push({
                title: 'Organizações x Categorias',
                description: 'Relatório organizações x categorias',
                link: `/${this.props.match.params.lang}/organizations-categories-report`,
                icon: AccountTree
            });
        }

        sections.push({
            id: 'relatorios',
            title: 'Relatórios',
            subtitle: 'Todos os relatórios do sistema',
            icon: Assessment,
            items: reportItems
        });

        // 15. CONFIGURAÇÕES - Com controle de permissões baseado no arquivo original
        const configItems = [];

        // Ações padrão - baseado na permissão DefaultAccompaniment
        if (this.context.can('List', 'DefaultAccompaniment')) {
            configItems.push({
                title: 'Ações padrão',
                description: 'Configure ações padrão',
                link: `/${this.props.match.params.lang}/default-actions`,
                icon: Settings
            });
        }

        // Atividades
        if (this.context.can('List', 'Activity')) {
            configItems.push({
                title: 'Atividades',
                description: 'Configure atividades',
                link: `/${this.props.match.params.lang}/activity-list`,
                icon: Assignment
            });
        }

        // Alertas
        if (this.context.can('List', 'Alert')) {
            configItems.push({
                title: 'Alertas',
                description: 'Configure alertas',
                link: `/${this.props.match.params.lang}/alert-list`,
                icon: NotificationsActive
            });
        }

        // Categorias
        if (this.context.can('List', 'Category')) {
            configItems.push({
                title: 'Categorias',
                description: 'Gerencie categorias',
                link: `/${this.props.match.params.lang}/categories`,
                icon: Category
            });
        }

        // Configurações gerais
        if (this.context.can('List', 'Config')) {
            configItems.push({
                title: 'Configurações',
                description: 'Configurações gerais',
                link: `/${this.props.match.params.lang}/configs`,
                icon: Settings,
                subItems: [
                    'Configurações gerais',
                    'Caixa de email',
                    'Aparência do sistema',
                    'Aparência do E-mail',
                    'Configurações de Comunicação',
                    'Politicas de senha e segurança',
                    'Política de autenticação de dois fatores',
                    'Portal do Cliente',
                    'Configurações de chamados',
                    'Configurações de usuários',
                    'Configurações de artigos'
                ]                
            });
        }

        if (this.context.can('List', 'EmailCustomSettings')) {
            configItems.push({
                title: this.props.intl.formatMessage({ id: 'menu.emailtemplates' }),
                description: this.props.intl.formatMessage({ id: 'menu.emailtemplates.description' }),
                link: `/${this.props.match.params.lang}/email-templates`,
                icon: Mail
            });
        }
        if (this.context.can('List', 'EmailCustomSettings')) {
            configItems.push({
                title: this.props.intl.formatMessage({ id: 'menu.statusemailnotifications' }),
                description: this.props.intl.formatMessage({ id: 'menu.statusemailnotifications.description' }),
                link: `/${this.props.match.params.lang}/status-email-notifications`,
                icon: NotificationsActive
            });
        }

        // Estratégia de Distribuição
        if (this.context.can('List', 'DistributionStrategy')) {
            if (!this.isAdmOrg) {
                configItems.push({
                    title: 'Estratégia de Distribuição',
                    description: 'Configure estratégias',
                    link: `/${this.props.match.params.lang}/distributionstrategies`,
                    icon: ShareIcon
                });
            }
        }

        // Usuários e Acesso
        const userItems = [];

        if (this.context.can('List', 'User')) {
            userItems.push({
                title: 'Usuários Agentes',
                description: 'Gerencie usuários do sistema',
                link: `/${this.props.match.params.lang}/users`,
                icon: GroupAdd
            });

            userItems.push({
                title: 'Usuários Clientes',
                description: 'Gerencie usuários clientes',
                link: `/${this.props.match.params.lang}/users-client`,
                icon: GroupAdd
            });
        }

        if (this.context.can('List', 'Permission')) {
            userItems.push({
                title: 'Funcionalidades',
                description: 'Configure funcionalidades do sistema',
                link: `/${this.props.match.params.lang}/permissions`,
                icon: Security
            });
        }

        if (this.context.can('List', 'Role')) {
            userItems.push({
                title: 'Perfil de Acesso',
                description: 'Configure perfis de acesso',
                link: `/${this.props.match.params.lang}/roles`,
                icon: VpnKey
            });
        }

        if (this.context.can('List', 'TechinicalTeamOrganizationCategory')) {
            userItems.push({
                title: 'Time x Categorias',
                description: 'Relacione times com categorias',
                link: `/${this.props.match.params.lang}/techinicalteamorganizationcategories`,
                icon: Category
            });
        }

        if (this.context.can('List', 'TechinicalTeamOrganization')) {
            userItems.push({
                title: 'Time x Organizações',
                description: 'Relacione times com organizações',
                link: `/${this.props.match.params.lang}/techinicalteamorganizations`,
                icon: AccountBalance
            });
        }

        if (this.govRevertAllowed) {
            userItems.push({
                title: 'Reverter unificação gov.br',
                description: 'Restaure o login de usuários unificados com o gov.br',
                link: `/${this.props.match.params.lang}/gov-unification-revert`,
                icon: ManageAccounts
            });
        }

        if (userItems.length > 0) {
            sections.push({
                id: 'usuarios',
                title: 'Usuários e Permissões',
                subtitle: 'Administre usuários, permissões e acessos',
                icon: GroupAdd,
                items: userItems
            });
        }



        // Organizações - Seção separada
        /*
            const organizationItems = [];
         
            if (this.isAdmGlobal || this.isAdm) {
              organizationItems.push({
                title: 'Organizações',
                description: 'Gerencie organizações',
                link: `/${this.props.match.params.lang}/organizations`,
                icon: AccountBalance
              });
         
              if (this.context.can('List', 'OrganizationCategory')) {
                organizationItems.push({
                  title: 'Categorias de Organização',
                  description: 'Categorias de organizações',
                  link: `/${this.props.match.params.lang}/organizationcategories`,
                  icon: LocationCity
                });
              }
         
              if (this.context.can('List', 'OrganizationSla')) {
                organizationItems.push({
                  title: 'SLA de Organizações',
                  description: 'Gerencie SLAs organizacionais',
                  link: `/${this.props.match.params.lang}/organizationslas`,
                  icon: AccessTimeFilled
                });
              }
         
              // Configurações de organização
              organizationItems.push({
                title: 'Configurações de Organização',
                description: 'Configurações organizacionais',
                link: `/${this.props.match.params.lang}/organizationsettings`,
                icon: SettingsApplications
              });
         
              // Listas de Dados de Chamados
              organizationItems.push({
                title: 'Listas de Dados de Chamados',
                description: 'Configure listas de dados de chamados',
                link: `/${this.props.match.params.lang}/calledlistdatas`,
                icon: Assessment
              });
         
              // Configurações de Custo Adicional
              organizationItems.push({
                title: 'Configurações de Custo Adicional',
                description: 'Configure custos adicionais',
                link: `/${this.props.match.params.lang}/additional-services-config`,
                icon: Assessment
              });
         
              // Configurações de Relatórios de Chamados
              organizationItems.push({
                title: 'Configurações de Relatórios',
                description: 'Configure relatórios de chamados',
                link: `/${this.props.match.params.lang}/called-report-configs`,
                icon: Assessment
              });
         
              // Departamentos da Organização
              if (this.context.can('List', 'OrganizationDepartament')) {
                organizationItems.push({
                  title: 'Departamentos da Organização',
                  description: 'Gerencie departamentos organizacionais',
                  link: `/${this.props.match.params.lang}/organizationdepartaments`,
                  icon: Groups
                });
              }
         
              // Materiais da Organização
              if (this.context.can('List', 'OrganizationMaterial')) {
                organizationItems.push({
                  title: 'Materiais da Organização',
                  description: 'Gerencie materiais organizacionais',
                  link: `/${this.props.match.params.lang}/organizationmaterials`,
                  icon: Build
                });
              }
         
              // Patrimônios da Organização
              if (this.context.can('List', 'OrganizationPatrimony')) {
                organizationItems.push({
                  title: 'Patrimônios da Organização',
                  description: 'Gerencie patrimônios organizacionais',
                  link: `/${this.props.match.params.lang}/organizationpatrimonies`,
                  icon: HomeWork
                });
              }
         
              // Relatório de Categorias de Organização
              if (this.context.can('List', 'CalledReport')) {
                organizationItems.push({
                  title: 'Relatório de Categorias',
                  description: 'Relatório de categorias de organizações',
                  link: `/${this.props.match.params.lang}/organizations-categories-report`,
                  icon: BarChart
                });
              }
            }
         
            // Sempre mostrar seção organizações, mesmo se vazia
            sections.push({
              id: 'organizacoes',
              title: 'Organizações',
              subtitle: 'Gestão organizacional e configurações',
              icon: AccountBalance,
              items: organizationItems
            });
        */

        // Grupo de Atendimento (Equipes Técnicas)
        if (this.isAdm == true || this.isAdmOrg == true || this.isAdmGlobal == true) {

            const serviceGroupItems = [];

            if (this.context.can('List', 'TechinicalTeam')) {
                serviceGroupItems.push({
                    title: 'Times',
                    description: 'Gerencie times técnicos',
                    link: `/${this.props.match.params.lang}/techinicalteams`,
                    icon: Groups
                });
            }

            if (this.context.can('List', 'TechinicalTeamOrganizationCategory')) {
                serviceGroupItems.push({
                    title: 'Time x Categorias',
                    description: 'Associe times com categorias',
                    link: `/${this.props.match.params.lang}/techinicalteamorganizationcategories`,
                    icon: Category
                });
            }

            if (this.context.can('List', 'TechinicalTeamOrganization')) {
                serviceGroupItems.push({
                    title: 'Time x Organizações',
                    description: 'Associe times com organizações',
                    link: `/${this.props.match.params.lang}/techinicalteamorganizations`,
                    icon: AccountBalance
                });
            }

            if (this.context.can('List', 'TechinicalTeamUser')) {
                serviceGroupItems.push({
                    title: 'Times x Técnicos',
                    description: 'Associe técnicos aos times',
                    link: `/${this.props.match.params.lang}/techinicalteamusers`,
                    icon: GroupAdd
                });
            }

            if (serviceGroupItems.length > 0) {
                sections.push({
                    id: 'grupos-atendimento',
                    title: 'Grupo de Atendimento',
                    subtitle: 'Gestão de grupos e equipes de atendimento',
                    icon: SpeakerGroup,
                    items: serviceGroupItems
                });
            }
        }

        if (!this.isClient) {
            // Pausas de Trabalho
            const workBreakItems = [];

            if (this.isAdmGlobal || this.isAdm) {
                workBreakItems.push({
                    title: 'Colaboradores em Pausa',
                    description: 'Visualize colaboradores que estão em pausa de trabalho em tempo real',
                    link: `/${this.props.match.params.lang}/break-work-collaborators-active`,
                    icon: TimelapseRounded
                });
            }

            workBreakItems.push({
                title: 'Minhas Pausas',
                description: 'Visualize suas pausas de trabalho e iniciar/encerrar pausas',
                link: `/${this.props.match.params.lang}/break-work-me`,
                icon: AccessTimeFilled
            });

            if (this.isAdmGlobal || this.isAdm) {
                workBreakItems.push({
                    title: 'Motivos de Intervalo',
                    description: 'Configure motivos de intervalo',
                    link: `/${this.props.match.params.lang}/break-reasons`,
                    icon: Schedule
                });
            }

            sections.push({
                id: 'pausas-trabalho',
                title: 'Pausas de Trabalho',
                subtitle: 'Gerencie suas pausas de trabalho e configure motivos de intervalo',
                icon: AccessTimeFilled,
                items: workBreakItems
            });
        }

        // Expediente
        if (this.context.can('List', 'WorkHour')) {
            configItems.push({
                title: 'Expediente',
                description: 'Configure expediente',
                link: `/${this.props.match.params.lang}/workhours`,
                icon: Schedule
            });

            // Feriados
            if (this.context.can('List', 'Holiday')) {
                if (!this.isAdmOrg) {
                    configItems.push({
                        title: 'Feriados',
                        description: 'Configure feriados',
                        link: `/${this.props.match.params.lang}/holidays`,
                        icon: EventNote
                    });
                }
            }

            // Grupos de Patrimônio
            if (this.context.can('List', 'PatrimonyGroup')) {
                configItems.push({
                    title: 'Grupos de Patrimônio',
                    description: 'Gerencie grupos de patrimônio',
                    link: `/${this.props.match.params.lang}/patrimonygroups`,
                    icon: Widgets
                });
            }

            // Materiais
            if (this.context.can('List', 'Material')) {
                configItems.push({
                    title: 'Materiais / Insumos',
                    description: 'Gerencie materiais e insumos',
                    link: `/${this.props.match.params.lang}/materials`,
                    icon: Inventory
                });
            }

            // Materiais de Patrimônio
            if (this.context.can('List', 'PatrimonyMaterial')) {
                configItems.push({
                    title: 'Materiais de Patrimônio',
                    description: 'Materiais de patrimônio',
                    link: `/${this.props.match.params.lang}/patrimonymaterials`,
                    icon: HomeWork
                });
            }

            // Motivos/Segmentos
            if (this.context.can('List', 'Segment')) {
                configItems.push({
                    title: 'Motivos',
                    description: 'Configure motivos',
                    link: `/${this.props.match.params.lang}/reasons`,
                    icon: Help
                });
            }

            // Origem dos Chamados
            if (this.context.can('List', 'OriginRequest')) {
                configItems.push({
                    title: 'Origem dos Chamados',
                    description: 'Configure origens',
                    link: `/${this.props.match.params.lang}/originrequests`,
                    icon: Source
                });
            }

            // Portal do Cliente
            if (this.isAdm || this.isAdmGlobal) {
                configItems.push({
                    title: 'Portal do Cliente',
                    description: 'Configure portal do cliente',
                    link: `/${this.props.match.params.lang}/client-portal`,
                    icon: Web
                });
            }

            // Prioridades - sem permissão específica no original
            if (!this.isAdmOrg) {
                configItems.push({
                    title: 'Prioridades',
                    description: 'Configure prioridades',
                    link: `/${this.props.match.params.lang}/priorities`,
                    icon: PriorityHigh
                });
            }

            // Pesquisa de satisfação
            if (this.context.can('List', 'SatisfactionSurvey')) {
                configItems.push({
                    title: 'Pesquisa de satisfação',
                    description: 'Configure pesquisas',
                    link: `/${this.props.match.params.lang}/satisfactionsurveys`,
                    icon: ThumbUp
                });
            }

            // Segmentos
            if (this.context.can('List', 'Segment')) {
                configItems.push({
                    title: 'Segmentos',
                    description: 'Gerencie segmentos organizacionais',
                    link: `/${this.props.match.params.lang}/segments`,
                    icon: Segment
                });
            }

            // Situação do chamado no encerramento
            if (this.context.can('List', 'CalledClosingStatus')) {
                if (!this.isAdmOrg) {
                    configItems.push({
                        title: 'Situação do chamado no encerramento',
                        description: 'Configure situações de encerramento',
                        link: `/${this.props.match.params.lang}/called-closing-statuses`,
                        icon: Timer
                    });
                }
            }

            // SLA
            if (this.context.can('List', 'Sla')) {
                if (!this.isAdmOrg) {
                    configItems.push({
                        title: 'SLA',
                        description: 'Configure acordos de nível de serviço',
                        link: `/${this.props.match.params.lang}/slas`,
                        icon: Timer
                    });
                }
            }

            // Status
            if (this.context.can('List', 'Status')) {
                configItems.push({
                    title: 'Status',
                    description: 'Configure status de chamados',
                    link: `/${this.props.match.params.lang}/status`,
                    icon: FiberManualRecord
                });
            }

            // Subgrupos de Patrimônio
            if (this.context.can('List', 'PatrimonySubGroup')) {
                configItems.push({
                    title: 'Subgrupos de Patrimônio',
                    description: 'Subgrupos de patrimônio',
                    link: `/${this.props.match.params.lang}/patrimonysubgroups`,
                    icon: AccountTree
                });
            }

            // Tipos
            if (this.context.can('List', 'Type')) {
                configItems.push({
                    title: 'Tipos de Chamado',
                    description: 'Configure tipos de chamados',
                    link: `/${this.props.match.params.lang}/types`,
                    icon: Category
                });
            }

            // Tipo de Contagem do SLA
            if (this.context.can('List', 'SlaCountType')) {
                if (!this.isAdmOrg) {
                    configItems.push({
                        title: 'Tipo de Contagem do SLA',
                        description: 'Configure tipos de contagem SLA',
                        link: `/${this.props.match.params.lang}/slacounttypes`,
                        icon: Timer
                    });
                }
            }

            // Unidades
            if (this.context.can('List', 'Config')) {
                configItems.push({
                    title: 'Unidades',
                    description: 'Gerencie unidades organizacionais',
                    link: `/${this.props.match.params.lang}/units`,
                    icon: Business
                });
            }

            // Tags
            if (this.context.can('List', 'Tags')) {
                configItems.push({
                    title: 'Tags',
                    description: 'Gerencie tags do sistema',
                    link: `/${this.props.match.params.lang}/tags`,
                    icon: LocalOffer
                });
            }

            // Adicionar condição para seção ser mostrada apenas se há itens
            if (configItems.length > 0) {
                sections.push({
                    id: 'configuracoes',
                    title: 'Configurações',
                    subtitle: 'Configurações gerais do sistema',
                    icon: Settings,
                    items: configItems
                });
            }
        }

        // Administração (Configurações gerais, etc)
        // const adminItems = [];

        // // Ações padrão
        // if (this.context.can('List', 'DefaultAction')) {
        //     adminItems.push({
        //         title: 'Ações padrão',
        //         description: 'Configure ações padrão do sistema',
        //         link: `/${this.props.match.params.lang}/default-actions`,
        //         icon: SettingsApplications
        //     });
        // }

        // // Atividades
        // if (this.context.can('List', 'Activity')) {
        //     adminItems.push({
        //         title: 'Atividades',
        //         description: 'Configure atividades do sistema',
        //         link: `/${this.props.match.params.lang}/activity-list`,
        //         icon: Assignment
        //     });
        // }

        // // Alertas
        // if (this.context.can('List', 'Alert')) {
        //     adminItems.push({
        //         title: 'Alertas',
        //         description: 'Configure alertas do sistema',
        //         link: `/${this.props.match.params.lang}/alert-list`,
        //         icon: Feedback
        //     });
        // }

        // // Categorias
        // if (this.context.can('List', 'Category')) {
        //     adminItems.push({
        //         title: 'Categorias',
        //         description: 'Gerencie categorias de chamados',
        //         link: `/${this.props.match.params.lang}/categories`,
        //         icon: Category
        //     });
        // }

        // // Configurações gerais
        // if (this.context.can('List', 'Config')) {
        //     adminItems.push({
        //         title: 'Configurações',
        //         description: 'Configurações gerais do sistema',
        //         link: `/${this.props.match.params.lang}/configs`,
        //         icon: Settings
        //     });
        // }

        // // Estratégia de Distribuição
        // if (this.context.can('List', 'DistributionStrategy')) {
        //     adminItems.push({
        //         title: 'Estratégia de Distribuição',
        //         description: 'Configure estratégias de distribuição',
        //         link: `/${this.props.match.params.lang}/distributionstrategies`,
        //         icon: Settings
        //     });
        // }

        // // Expediente
        // if (this.context.can('List', 'WorkHour')) {
        //     adminItems.push({
        //         title: 'Expediente',
        //         description: 'Configure horários de trabalho',
        //         link: `/${this.props.match.params.lang}/workhours`,
        //         icon: Schedule
        //     });
        // }

        // // Feriados
        // if (this.context.can('List', 'Holiday')) {
        //     adminItems.push({
        //         title: 'Feriados',
        //         description: 'Configure feriados',
        //         link: `/${this.props.match.params.lang}/holidays`,
        //         icon: Today
        //     });
        // }

        // // Grupos de Patrimônio
        // if (this.context.can('List', 'PatrimonyGroup')) {
        //     adminItems.push({
        //         title: 'Grupos de Patrimônio',
        //         description: 'Gerencie grupos de patrimônio',
        //         link: `/${this.props.match.params.lang}/patrimonygroups`,
        //         icon: Widgets
        //     });
        // }

        // // Idiomas
        // if (this.context.can('List', 'Language')) {
        //     adminItems.push({
        //         title: 'Idiomas',
        //         description: 'Configure idiomas do sistema',
        //         link: `/${this.props.match.params.lang}/languages`,
        //         icon: Language
        //     });
        // }

        // // Localizações
        // if (this.context.can('List', 'Location')) {
        //     adminItems.push({
        //         title: 'Localizações',
        //         description: 'Gerencie localizações',
        //         link: `/${this.props.match.params.lang}/locations`,
        //         icon: LocationOn
        //     });
        // }

        // // Materiais
        // if (this.context.can('List', 'Material')) {
        //     adminItems.push({
        //         title: 'Materiais',
        //         description: 'Gerencie materiais e recursos',
        //         link: `/${this.props.match.params.lang}/materials`,
        //         icon: Inventory
        //     });
        // }

        // // Patrimônios
        // if (this.context.can('List', 'Patrimony')) {
        //     adminItems.push({
        //         title: 'Patrimônios',
        //         description: 'Gerencie patrimônios',
        //         link: `/${this.props.match.params.lang}/patrimony`,
        //         icon: HomeWork
        //     });
        // }

        // // Portal do Cliente
        // if (this.context.can('List', 'ClientPortal')) {
        //     adminItems.push({
        //         title: 'Portal do Cliente',
        //         description: 'Configure portal do cliente',
        //         link: `/${this.props.match.params.lang}/clientportal`,
        //         icon: Web
        //     });
        // }

        // // Pesquisa de Satisfação
        // if (this.context.can('List', 'SatisfactionSurvey')) {
        //     adminItems.push({
        //         title: 'Pesquisa de Satisfação',
        //         description: 'Configure pesquisas de satisfação',
        //         link: `/${this.props.match.params.lang}/satisfactionsurveys`,
        //         icon: ThumbUp
        //     });
        // }

        // // Prioridades
        // if (this.context.can('List', 'Priority')) {
        //     adminItems.push({
        //         title: 'Prioridades',
        //         description: 'Gerencie prioridades de chamados',
        //         link: `/${this.props.match.params.lang}/priorities`,
        //         icon: PriorityHigh
        //     });
        // }

        // // Produtos e Serviços
        // if (this.context.can('List', 'ProductService')) {
        //     adminItems.push({
        //         title: 'Produtos e Serviços',
        //         description: 'Gerencie produtos e serviços',
        //         link: `/${this.props.match.params.lang}/productservices`,
        //         icon: ShoppingCart
        //     });
        // }

        // // SLA
        // if (this.context.can('List', 'SLA')) {
        //     adminItems.push({
        //         title: 'SLA',
        //         description: 'Configure acordos de nível de serviço',
        //         link: `/${this.props.match.params.lang}/slas`,
        //         icon: Timer
        //     });
        // }

        // // Status
        // if (this.context.can('List', 'Status')) {
        //     adminItems.push({
        //         title: 'Status',
        //         description: 'Gerencie status de chamados',
        //         link: `/${this.props.match.params.lang}/status`,
        //         icon: FiberManualRecord
        //     });
        // }

        // // Tags
        // if (this.context.can('List', 'Tag')) {
        //     adminItems.push({
        //         title: 'Tags',
        //         description: 'Gerencie tags do sistema',
        //         link: `/${this.props.match.params.lang}/tags`,
        //         icon: LocalOffer
        //     });
        // }

        // // Tipos
        // if (this.context.can('List', 'Type')) {
        //     adminItems.push({
        //         title: 'Tipos',
        //         description: 'Gerencie tipos de chamados',
        //         link: `/${this.props.match.params.lang}/types`,
        //         icon: Category
        //     });
        // }

        // // Materiais / Insumos
        // if (this.context.can('List', 'Material')) {
        //     adminItems.push({
        //         title: 'Materiais / Insumos',
        //         description: 'Gerencie materiais e insumos',
        //         link: `/${this.props.match.params.lang}/materials`,
        //         icon: Build
        //     });
        // }

        // // Materiais de Patrimônio
        // if (this.context.can('List', 'PatrimonyMaterial')) {
        //     adminItems.push({
        //         title: 'Materiais de Patrimônio',
        //         description: 'Gerencie materiais de patrimônio',
        //         link: `/${this.props.match.params.lang}/patrimonymaterials`,
        //         icon: Build
        //     });
        // }

        // // Motivos
        // if (this.context.can('List', 'Reason')) {
        //     adminItems.push({
        //         title: 'Motivos',
        //         description: 'Gerencie motivos do sistema',
        //         link: `/${this.props.match.params.lang}/reasons`,
        //         icon: Category
        //     });
        // }

        // // Origem dos Chamados
        // if (this.context.can('List', 'OriginRequest')) {
        //     adminItems.push({
        //         title: 'Origem dos Chamados',
        //         description: 'Configure origens de chamados',
        //         link: `/${this.props.match.params.lang}/originrequests`,
        //         icon: ContactPhone
        //     });
        // }

        // // Portal do Cliente
        // adminItems.push({
        //     title: 'Portal do Cliente',
        //     description: 'Configure portal do cliente',
        //     link: `/${this.props.match.params.lang}/client-portal`,
        //     icon: AccountBalance
        // });

        // // Prioridades
        // if (this.context.can('List', 'Priority')) {
        //     adminItems.push({
        //         title: 'Prioridades',
        //         description: 'Configure prioridades de chamados',
        //         link: `/${this.props.match.params.lang}/priorities`,
        //         icon: Assignment
        //     });
        // }

        // // Pesquisa de satisfação
        // if (this.context.can('List', 'SatisfactionSurvey')) {
        //     adminItems.push({
        //         title: 'Pesquisa de satisfação',
        //         description: 'Configure pesquisas de satisfação',
        //         link: `/${this.props.match.params.lang}/satisfaction-survey-list`,
        //         icon: ThumbUp
        //     });
        // }

        // // Segmentos
        // if (this.context.can('List', 'Segment')) {
        //     adminItems.push({
        //         title: 'Segmentos',
        //         description: 'Gerencie segmentos',
        //         link: `/${this.props.match.params.lang}/segments`,
        //         icon: Category
        //     });
        // }

        // // Situação do chamado no encerramento
        // if (this.context.can('List', 'CalledClosingStatus')) {
        //     adminItems.push({
        //         title: 'Situação do chamado no encerramento',
        //         description: 'Configure situações de encerramento',
        //         link: `/${this.props.match.params.lang}/called-closing-statuses`,
        //         icon: CheckCircle
        //     });
        // }

        // // SLA Atendimento / Solução por mês
        // if (this.context.can('List', 'Sla')) {
        //     adminItems.push({
        //         title: 'SLA Atendimento / Solução por mês',
        //         description: 'Configure SLAs mensais',
        //         link: `/${this.props.match.params.lang}/slas`,
        //         icon: AccessTimeFilled
        //     });
        // }

        // // Status
        // if (this.context.can('List', 'Status')) {
        //     adminItems.push({
        //         title: 'Status',
        //         description: 'Configure status de chamados',
        //         link: `/${this.props.match.params.lang}/statuses`,
        //         icon: Assignment
        //     });
        // }

        // // Subgrupos de Patrimônio
        // if (this.context.can('List', 'PatrimonySubgroup')) {
        //     adminItems.push({
        //         title: 'Subgrupos de Patrimônio',
        //         description: 'Gerencie subgrupos de patrimônio',
        //         link: `/${this.props.match.params.lang}/patrimonysubgroups`,
        //         icon: Widgets
        //     });
        // }

        // // Tipos de Chamado
        // if (this.context.can('List', 'Type')) {
        //     adminItems.push({
        //         title: 'Tipos de Chamado',
        //         description: 'Gerencie tipos de chamados',
        //         link: `/${this.props.match.params.lang}/types`,
        //         icon: Category
        //     });
        // }

        // // Tipo de Contagem do SLA
        // if (this.context.can('List', 'SlaCountType')) {
        //     adminItems.push({
        //         title: 'Tipo de Contagem do SLA',
        //         description: 'Configure tipos de contagem SLA',
        //         link: `/${this.props.match.params.lang}/slacounttypes`,
        //         icon: Timer
        //     });
        // }

        // // Unidades
        // if (this.context.can('List', 'Unit')) {
        //     adminItems.push({
        //         title: 'Unidades',
        //         description: 'Configure unidades de medida',
        //         link: `/${this.props.match.params.lang}/units`,
        //         icon: BusinessCenter
        //     });
        // }

        // // Tags
        // if (this.context.can('List', 'Tag')) {
        //     adminItems.push({
        //         title: 'Tags',
        //         description: 'Gerencie tags do sistema',
        //         link: `/${this.props.match.params.lang}/tags-list`,
        //         icon: LocalOffer
        //     });
        // }

        // // SLA
        // if (this.context.can('List', 'Sla')) {
        //     adminItems.push({
        //         title: 'SLA',
        //         description: 'Configure acordos de nível de serviço',
        //         link: `/${this.props.match.params.lang}/slas`,
        //         icon: AccessTimeFilled
        //     });
        // }

        // // Base de Conhecimento
        // if (this.context.can('List', 'KnowledgeBase')) {
        //     adminItems.push({
        //         title: 'Base de Conhecimento',
        //         description: 'Gerencie a base de conhecimento',
        //         link: `/${this.props.match.params.lang}/knowledgebases`,
        //         icon: EmojiObjects
        //     });
        // }

        // adminItems.push({
        //     title: 'Artigos',
        //     description: 'Gerencie artigos de conhecimento',
        //     link: `/${this.props.match.params.lang}/articles`,
        //     icon: EmojiObjects
        // });

        // adminItems.push({
        //     title: 'FAQ - Assuntos',
        //     description: 'Gerencie assuntos do FAQ',
        //     link: `/${this.props.match.params.lang}/faq-subject`,
        //     icon: EmojiObjects
        // });

        // // Intervalos de Trabalho
        // adminItems.push({
        //     title: 'Registro de Intervalos',
        //     description: 'Registre intervalos de trabalho',
        //     link: `/${this.props.match.params.lang}/break-reason-registration`,
        //     icon: AccessTimeFilled
        // });

        // adminItems.push({
        //     title: 'Motivos de Intervalo',
        //     description: 'Configure motivos de intervalo',
        //     link: `/${this.props.match.params.lang}/break-reasons`,
        //     icon: AccessTimeFilled
        // });


        // // Configurações Gerais
        // if (this.context.can('List', 'DefaultAccompaniment')) {
        //     adminItems.push({
        //         title: 'Ações Padrão',
        //         description: 'Configure ações padrão do sistema',
        //         link: `/${this.props.match.params.lang}/default-actions`,
        //         icon: SettingsApplications
        //     });
        // }

        // if (this.context.can('List', 'Activity')) {
        //     adminItems.push({
        //         title: 'Atividades',
        //         description: 'Gerencie tipos de atividades',
        //         link: `/${this.props.match.params.lang}/activity-list`,
        //         icon: SettingsApplications
        //     });
        // }

        // if (this.context.can('List', 'Alert')) {
        //     adminItems.push({
        //         title: 'Alertas',
        //         description: 'Configure alertas do sistema',
        //         link: `/${this.props.match.params.lang}/alert-list`,
        //         icon: SettingsApplications
        //     });
        // }

        // if (this.context.can('List', 'WorkHour')) {
        //     adminItems.push({
        //         title: 'Horários de Trabalho',
        //         description: 'Configure horários de trabalho',
        //         link: `/${this.props.match.params.lang}/workhours`,
        //         icon: AccessTimeFilled
        //     });
        // }

        // if (this.context.can('List', 'Holiday')) {
        //     adminItems.push({
        //         title: 'Feriados',
        //         description: 'Gerencie feriados',
        //         link: `/${this.props.match.params.lang}/holidays`,
        //         icon: CalendarMonth
        //     });
        // }

        // // Integrações
        // if (this.isAdmGlobal) {
        //     adminItems.push({
        //         title: 'Autenticação',
        //         description: 'Configure autenticação',
        //         link: `/${this.props.match.params.lang}/authentication`,
        //         icon: IntegrationInstructions
        //     });

        //     adminItems.push({
        //         title: 'Serviços de Integração',
        //         description: 'Configure integrações',
        //         link: `/${this.props.match.params.lang}/integration-service`,
        //         icon: IntegrationInstructions
        //     });

        //     adminItems.push({
        //         title: 'Variáveis de Integração',
        //         description: 'Variáveis de usuário para integrações',
        //         link: `/${this.props.match.params.lang}/variable`,
        //         icon: IntegrationInstructions
        //     });

        //     adminItems.push({
        //         title: 'Automações',
        //         description: 'Configure automações',
        //         link: `/${this.props.match.params.lang}/automationV2`,
        //         icon: AutomationIcon
        //     });

        //     adminItems.push({
        //         title: 'LLMs (IA)',
        //         description: 'Configure modelos de linguagem',
        //         link: `/${this.props.match.params.lang}/llms`,
        //         icon: SmartToy
        //     });

        //     adminItems.push({
        //         title: 'Eventos de LLM',
        //         description: 'Monitore eventos de IA',
        //         link: `/${this.props.match.params.lang}/llm-events`,
        //         icon: SmartToy
        //     });
        // }

        // if (adminItems.length > 0) {
        //     sections.push({
        //         id: 'administracao',
        //         title: 'Administração',
        //         subtitle: 'Configurações administrativas e gerenciamento do sistema',
        //         icon: SettingsApplications,
        //         items: adminItems
        //     });
        // }

        // Filtrar seções que têm pelo menos um item (exceto comunicação e organizações que sempre aparecem)
        const validSections = sections.filter(section =>
            section.id === 'recentes' ||
            section.id === 'comunicacao' ||
            section.id === 'organizacoes' ||
            (section.items && section.items.length > 0)
        );

        this.setState({ sections: validSections });
    };

    handleSearch = (event) => {
        this.setState({ searchTerm: event.target.value });
    };

    handleAnchorClick = (sectionId) => {
        this.setState({ activeSection: sectionId });
        window.location.hash = sectionId;
    };

    handleCardClick = (link) => {
        // Encontrar o item clicado
        const allItems = this.state.sections.flatMap(s => s.items || []);
        const clickedItem = allItems.find(item => item.link === link);

        if (clickedItem) {
            // Salvar como item recente (automaticamente ordena e limita a 3)
            this.saveRecentItem(clickedItem);
        }

        // Navegar para o link
        this.props.history.push(link);
    };
    normalizeText = (text) => {
        if (!text) return '';
        return text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    };

    getFilteredSectionsOld = () => {
        const { searchTerm, sections } = this.state;
        if (!searchTerm) return sections;

        return sections.map(section => ({
            ...section,
            items: section.items?.filter(item =>
                item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                this.normalizeText(item.title).includes(searchTerm.toLowerCase()) ||
                this.normalizeText(item.description).includes(searchTerm.toLowerCase())

            )
        })).filter(section =>
            section.id === 'recentes' || (section.items && section.items.length > 0)
        );
    };
    getFilteredSections = () => {
        const { searchTerm, sections } = this.state;
        if (!searchTerm) return sections;

        const normalizedSearch = this.normalizeText(searchTerm);

        return sections.map(section => ({
            ...section,
            items: section.items?.filter(item => {
                // Busca no título
                const titleMatch = this.normalizeText(item.title).includes(normalizedSearch);
                
                // Busca na descrição
                const descriptionMatch = this.normalizeText(item.description).includes(normalizedSearch);
                
                // Busca nos subitens (abas internas)
                const subItemsMatch = item.subItems?.some(subItem => 
                    this.normalizeText(subItem).includes(normalizedSearch)
                ) || false;
                
                return titleMatch || descriptionMatch || subItemsMatch;
            })
        })).filter(section =>
            section.id === 'recentes' || (section.items && section.items.length > 0)
        );
    };

    render() {
        const { classes } = this.props;
        const { searchTerm, activeSection } = this.state;
        const filteredSections = this.getFilteredSections();

        const theme = createTheme({
            palette: {
                primary: {
                    main: '#2979ff'
                }
            }
        });

        return (
            <Base>
                <ThemeProvider theme={theme}>
                    <Box className={classes.root}>
                        {/* Header */}
                        <Box className={classes.header}>
                            <Container maxWidth={false}>
                                <Box className={classes.headerContent}>
                                    <Typography className={classes.title}>
                                        Configurações e Administração
                                    </Typography>
                                    <TextField
                                        className={classes.searchField}
                                        placeholder="Pesquisar funcionalidades..."
                                        variant="outlined"
                                        size="small"
                                        value={searchTerm}
                                        onChange={this.handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search fontSize="small" color="action" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Container>
                        </Box>

                        {/* Content */}
                        <Box className={classes.contentContainer}>
                            {/* Sidebar with anchors */}
                            <Box className={classes.sidebar}>
                                <Box className={classes.sidebarTitle}>
                                    <ListAlt className={classes.sidebarTitleIcon} />
                                    <Typography component="span">
                                        Categorias
                                    </Typography>
                                </Box>
                                <List className={classes.anchorList}>
                                    {filteredSections.map((section) => (
                                        <ListItem
                                            key={section.id}
                                            className={`${classes.anchorItem} ${activeSection === section.id ? 'active' : ''}`}
                                            onClick={() => this.handleAnchorClick(section.id)}
                                        >
                                            <ListItemText
                                                primary={section.title}
                                                className={classes.anchorText}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>

                            {/* Main content */}
                            <Box id="admin-main-content" className={classes.mainContent}>
                                {filteredSections.map((section) => (
                                    <Box
                                        key={section.id}
                                        id={section.id}
                                        className={classes.section}
                                    >
                                        <Box className={classes.sectionHeader}>
                                            <Typography className={classes.sectionTitle}>
                                                <section.icon className={classes.sectionIcon} />
                                                {section.title}
                                            </Typography>
                                            <Typography className={classes.sectionSubtitle}>
                                                {section.subtitle}
                                            </Typography>
                                        </Box>

                                        <Grid container spacing={2} className={classes.cardsGrid}>
                                            {section.items && section.items.map((item, index) => (
                                                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                    <Card
                                                        className={`${classes.configCard} ${section.id === 'recentes' ? classes.recentCard : ''}`}
                                                        onClick={() => this.handleCardClick(item.link)}
                                                    >
                                                        {section.id === 'recentes' && (
                                                            <span className={classes.recentBadge}>RECENTE</span>
                                                        )}
                                                        <CardContent className={classes.cardContent}>
                                                            <Box className={classes.cardIcon}>
                                                                <item.icon className={classes.cardIconSvg} />
                                                            </Box>
                                                            <Box className={classes.cardInfo}>
                                                                <Typography className={classes.cardTitle}>
                                                                    {item.title}
                                                                </Typography>
                                                                <Typography className={classes.cardDescription}>
                                                                    {item.description}
                                                                </Typography>
                                                            </Box>
                                                            <ArrowForward className={classes.cardArrow} />
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>

                    {/* Botão flutuante "Ir para o topo" */}
                    <IconButton
                        className={`${classes.scrollToTopButton} ${this.state.showScrollToTop ? 'visible' : ''}`}
                        onClick={this.scrollToTop}
                        title="Ir para o topo"
                        color='primary'
                        style={{
                            color: "var(--mexx-green-light)",
                            backgroundColor: "var(--mexx-green-primary)",
                        }}
                    >
                        <KeyboardArrowUp />
                    </IconButton>
                </ThemeProvider>
            </Base>
        );
    }
}

const mapStateToProps = state => ({
    userSession: state.userSession,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(injectIntl(AdminMenu))));


